module.exports = __webpack_public_path__ + "static/media/Fiat.838186c1.png";